import { api, apiResolve, useApiPost } from '@sierralabs/core-ui';
// non-hook implementation
export function createEntityData(tableName, params) {
    const request = api.post(`entities/${tableName}`, params);
    return { request, result: apiResolve(request) };
}
export function useCreateEntityData(tableName) {
    const { data, isLoading, error, post } = useApiPost(`entities/${tableName}`);
    return {
        createdEntityData: data,
        isCreatingData: isLoading,
        error,
        createEntityData: post
    };
}
//# sourceMappingURL=useCreateEntityData.js.map